/* eslint-disable consistent-return */
import { Col, Layout, message, Row, Spin } from "antd";
import React, { useEffect, useState } from "react";
import Lottie from "react-lottie";
import { useNavigate, useLocation } from "react-router-dom";

import { getSupaClient } from "../../lib/supabase";
import animationData from "../../lottie/loading-people-magnify.json";

const queryString = require("query-string");

const { Content } = Layout;

const GithubAdded = (props) => {
  const supabase = getSupaClient();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const parsedArgs = queryString.parse(location.search);
  const { code } = parsedArgs;
  const installationId = parsedArgs.installation_id;

  const handleRedirect = async () => {
    // confirm OAuth code with slack and return user token
    const response = await fetch(`${process.env.REACT_APP_API}/addtogithub`, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        installationId,
        code,
        supaUser: supabase.auth.user(),
        reactAppURI: `${process.env.REACT_APP_URI}/settings`,
      }),
    });
    const data = await response.json();
    if (data.error) {
      message.error("Error connecting to Github, please reach out to support!");
    } else {
      message.success("Successfully connected Github!");
    }
    navigate("/settings");
    return data;
  };

  useEffect(() => {
    handleRedirect();
  }, []);

  return (
    <Content align="middle" style={{ minHeight: "100vh" }}>
      <p>Linking Github account...</p>
    </Content>
  );
};

export default GithubAdded;
